<style>
.bg {
  background-color: #fff !important;
}

</style>
<template>
  <v-app id="inspire">
    <vue-progress-bar></vue-progress-bar>
    <router-view />
  </v-app>
</template>
<script>

import DomainService from "@/services/domain.service";


export default {

  mounted: function() {
    try {
      let hostname = window.location.hostname;
      // hostname = "app.dataview365.com";
      DomainService.loadTitle(hostname);

    } catch(err) {

    }
    console.log("Application mounted ");

  }

}
</script>
